import { useHistory } from 'react-router-dom';

import { useQueryClient, useMutation } from '@tanstack/react-query';

import routes from '../../constants/routes';

import { FormulaStatus } from '../../models/formula.model';

// services
import API from '../../services/api';

// hooks
import useAnalytics from '../helper/useAnalytics';
import formulaKeys from './_queryKeys';

export default function useFormulaReview(formulaId: string) {
    const queryClient = useQueryClient();
    const history = useHistory();

    const { track } = useAnalytics();

    return useMutation({
        mutationFn: API.reviewFormula,
        onSuccess: ({ data }) => {
            history.replace(
                routes.formulaView(FormulaStatus.Review, formulaId),
            );
            track('formula_toggled_to_review', {
                formula_id: data.id,
            });
        },
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: formulaKeys.all });
        },
    });
}
